<template>
    <h2>1. 収集する情報について</h2>
    <p>当サイトでは、以下の情報を収集します。</p>
    <ul>
    <li><strong>ユーザー登録情報（Firebase Authentication を利用）</strong></li>
    <ul>
        <li>メールアドレス</li>
        <li>パスワード（当サイトでは直接アクセス・管理を行いません）</li>
        <li>ユーザー名</li>
    </ul>
    <li><strong>サービス利用情報</strong></li>
    <ul>
        <li>スタンプラリーの進行状況（Firestore に記録）</li>
        <li>ユーザーがアップロードした画像やデータ（Firebase Storage に保存）</li>
        <li>サイト利用状況（Google Analytics を使用）</li>
    </ul>
    </ul>

    <h2>2. 情報の利用目的</h2>
    <ul>
    <li>ユーザーの識別および認証</li>
    <li>スタンプラリーの運営および管理</li>
    <li>クーポンや特典の提供</li>
    <li>ユーザーサポートおよびお問い合わせ対応</li>
    <li>サービスの改善および利便性向上</li>
    <li>Google Analytics を利用したアクセス解析</li>
    </ul>

    <h2>3. 情報の管理</h2>
    <p>当サイトでは、ユーザーの個人情報を適切に管理し、不正アクセス、漏えい、改ざん、紛失等を防ぐため、必要な対策を講じます。</p>

    <h2>4. 第三者提供について</h2>
    <p>当サイトは、以下の場合を除き、第三者に個人情報を提供することはありません。</p>
    <ul>
    <li>ユーザーの同意がある場合</li>
    <li>法令に基づき提供が必要な場合</li>
    <li>サービス運営上必要な範囲で業務委託先に提供する場合（委託先には適切な管理を義務付けます）</li>
    </ul>

    <h2>5. クッキー（Cookie）について</h2>
    <p>当サイトでは、以下の目的で Cookie を使用する場合があります。</p>
    <ul>
    <li>Firebase Authentication を利用したログイン状態の維持</li>
    <li>Google Analytics によるアクセス解析</li>
    </ul>
    <p>Cookie の利用を希望されない場合は、ブラウザの設定で無効にすることができます。ただし、ログイン機能を含む一部の機能が正常に動作しなくなる可能性があります。</p>

    <h2>6. 個人情報の開示・訂正・削除について</h2>
    <p>ユーザーが自身の個人情報の開示、訂正、削除を希望される場合は、以下の問い合わせ先までご連絡ください。適切な本人確認の上、対応いたします。また、パスワードの変更やアカウント削除につきましては、当サイト「マイページ」より変更できます。</p>

    <h2>7. プライバシーポリシーの変更</h2>
    <p>本プライバシーポリシーは、必要に応じて改定される場合があります。改定後の内容は当サイト上に掲載し、告知いたします。</p>

    <h2>8. お問い合わせ先</h2>
    <p>プライバシーポリシーに関するお問い合わせは、以下までご連絡ください。</p>
    <p>メールアドレス：[お問い合わせ用のメールアドレスを記載]</p>
    <p>電話番号：[電話番号を記載]</p>

    <h2>制定日</h2>
    <p>2025年2月1日</p>
</template>